import { stripHtmlTagsOfArray } from "./stripHtmlTags";

export const convertHtmlListToStringArray = (props: string) =>
    stripHtmlTagsOfArray(props.split("\n")).filter((element) => element.length > 1);
